import { TypeHelper, ODataSelect } from "@iconics/core";

export class NodeData extends ODataSelect
{
    public ID = 0;
    public Parent_ID: (number | null) = 0;
    public Level = '';
    public DisplayName = '';
    public Name = '';
    public IsEnabled = 0;
}

export class ImportResultWrapper
{
    public Success: ImportResult = new ImportResult();
    public Failure: ImportResult = new ImportResult();
}

export class ImportResult
{
    public Equipments: string[] = [];
    public EquipmentProperties: string[] = [];
    public TreeViews: string[] = [];
}
